import { Flex, Heading, Img, Text } from '@chakra-ui/react';
import { dimensionGroupsApi } from '@texas/api/endpoints/metadata/dimensionGroupsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { clientEndpoints } from '@texas/clientEndpoints';
import { SpinnerWithLabel } from '@texas/components/shared/SpinnerWithLabel';
import { useEffect } from 'react';

interface Props {
  dimensionGroupId: number;
}

export function DimensionGroupHoverCard({ dimensionGroupId }: Props) {
  const { data, refetch, loading } = useApiResource(dimensionGroupsApi.get);

  useEffect(() => {
    refetch(dimensionGroupId);
  }, [dimensionGroupId, refetch]);

  if (loading) {
    return <SpinnerWithLabel label="Loading..." />;
  }

  return (
    <Flex gap={2}>
      {data?.visualFile?.identifier && (
        <Img
          maxH="24"
          objectFit="contain"
          borderRadius="md"
          w="fit-content"
          src={clientEndpoints.previewImage(data.visualFile.identifier, 128)}
        />
      )}
      <Flex gap={2} flexDir="column">
        <Heading fontSize="md">{data?.name}</Heading>
        <Text fontSize="sm">{data?.description}</Text>
      </Flex>
    </Flex>
  );
}
